module.exports = __webpack_public_path__ + "static/img/3.b68bcb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/bg/3.jpg
// module id = t0ho
// module chunks = 0